var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-footer"},[_c('div',{staticClass:"w-f-content"},[_c('KeepOnRecord'),_c('WFLine'),_c('QuickNavigation'),_c('WFLine'),_c('QrCodeDisplay')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }